import { Protocol } from './index';
import { Category } from '../constants';

const gamings: Protocol[] = [
  {
    name: 'Basepaint',
    url: 'https://basepaint.xyz/',
    logoPath: '/logos/basepaint.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/basepaint_xyz',
  },
  {
    name: 'Cat Town',
    url: 'https://www.cat.town/',
    logoPath: '/logos/cat_town.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/CatTownBase',
  },
  {
    name: 'Ducky City',
    url: 'https://duckycity.io/',
    logoPath: '/logos/ducky_city.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/duckycity_io',
  },
  {
    name: 'Ethxy',
    url: 'https://ethxy.com/',
    logoPath: '/logos/ethxy.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/ethxy',
  },
  {
    name: 'Game7',
    url: 'https://game7.io/',
    logoPath: '/logos/game7.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/G7_DAO',
  },
  {
    name: 'Heroes Of Mavia',
    url: 'https://www.mavia.com/',
    logoPath: '/logos/heroes_of_mavia.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/MaviaGame',
  },
  {
    name: 'Parallel',
    url: 'https://parallel.life/',
    logoPath: '/logos/parallel.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/ParallelTCG',
  },
  {
    name: 'Pixelmon',
    url: 'https://www.pixelmon.ai/',
    logoPath: '/logos/pixelmon.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/pixelmon',
  },
  {
    name: 'Yield Guild Games',
    url: 'https://yieldguild.io/',
    logoPath: '/logos/yield_guild_games.jpg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/yieldguild',
  },
  {
    name: 'Deribet',
    url: 'https://deribet.io/',
    logoPath: '/logos/deribet-logo-400.jpeg',
    category: Category.Gaming,
    twitterUrl: 'https://twitter.com/deribet_io',
  },
];

export { gamings };
